import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { DSAuthService } from '../../auth.service';

@Component({
  selector: 'mp-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['../shared/auth-form.scss'],
})
export class ForgotPasswordComponent implements OnInit {
  form: UntypedFormGroup;
  config;

  isEmailSent: boolean;

  constructor(public authService: DSAuthService) {}

  ngOnInit(): void {
    this.config = this.authService.configuration.forgot_password;
    this.form = new UntypedFormGroup({});
  }

  submit() {
    this.authService.submitForgotPassword(this.form.value);
    this.isEmailSent = true;
  }
}
